import React from 'react';

import LockIcon from '@mui/icons-material/Lock';
import { FormHelperText, Stack } from '@mui/material';

type Props = {
  fieldName?: string;
};

export function VccCreatedDisableFieldHelperText({ fieldName }: Props) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <LockIcon color="disabled" fontSize="inherit" />
      <FormHelperText>{fieldName ? `${fieldName} - VCC created` : 'VCC created - Locked'}</FormHelperText>
    </Stack>
  );
}
